/* eslint-disable camelcase */
export const getJWToken = () =>
  window.gon && window.gon.current_user && window.gon.current_user.jwt_token;

export const isComplaintsEnabled = () =>
  window.gon &&
  window.gon.company_settings &&
  window.gon.company_settings.complaints_enabled;

export const getIdpType = () =>
  window.gon &&
  window.gon.company_settings &&
  window.gon.company_settings.idp_type;
